import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface requestPaymentState {
    requestPaymen: any,
  }
  
const initialState:requestPaymentState = {
    requestPaymen: undefined,
}

export const requestPaymentSlice = createSlice({
    name:"requestPaymen",
    initialState,
    reducers:{
      
        AddPay: (state,action) => {
            state.requestPaymen = action.payload.requestPaymen
        },
       
    }
})

export const {AddPay} = requestPaymentSlice.actions

export const selectrequestPaymen = (state: RootState) => state.requestPaymen

export default requestPaymentSlice.reducer;